import { render, staticRenderFns } from "./Flux.vue?vue&type=template&id=249dfc08&scoped=true&"
import script from "./Flux.vue?vue&type=script&lang=js&"
export * from "./Flux.vue?vue&type=script&lang=js&"
import style0 from "./Flux.vue?vue&type=style&index=0&id=249dfc08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249dfc08",
  null
  
)

export default component.exports